<div class="output-error-text fxflex fxcentercenter">
  {{ 'Errors.Generic' | translate }}
</div>
